import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { Button, Nav, NavItem, NavLink } from 'reactstrap';
//Components
import MainCard from '../../../../../components/MainCard';
import Stepper from '../../../../../components/Stepper';
import Identificacao from './Identificacao';
import Etapas from './Etapas';
import Workflow from './Workflow';

//Helpers
import { validarCampos, objCampo } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../../helpers/message';

//Api
import tipoRequerimento_api from '../../../../../api/tipoRequerimento_api';

//Context
import { useAuth } from '../../../../../context/auth';

function initialStateTipoRequerimento() {
    return {
        identificacao: "",
        status: "Ativo",
        valorTaxaVistoria: "0,00",
        requerente: "Munícipe",
        arquivo: "",
        tipoRequerimentoDocumentos: [],
        tipoRequerimentoEtapas: [],
        tipoRequerimentoEtapasAcoes: [],

    }
}
export default function TipoDeRequerimentoStepper({ btnVoltar, id, editavel }) {
    const { setLoading } = useAuth();

    //Estado de controle do valor do tipo de requerimento a ser cadastrado
    const [tipoRequerimento, setTipoRequerimento] = useState(initialStateTipoRequerimento);

    //Estado de controle da exibição dos steps
    const [activeStep, setActiveStep] = useState(1);

    //Função de carregamento do tipo de requerimento
    const loadTipoRequerimento = (idTipoRequerimento = null) => {
        setLoading(true);
        tipoRequerimento_api.getItem(idTipoRequerimento ? idTipoRequerimento : tipoRequerimento.id).then(response => {
            response.data.valorTaxaVistoria = response.data?.valorTaxaVistoria ? response.data?.valorTaxaVistoria?.toFixed(2) : "0,00";
            response.data.tipoRequerimentoDocumentos.map(tipoRequerimentoDocumento => {
                tipoRequerimentoDocumento.id = tipoRequerimentoDocumento.id.toString();
                tipoRequerimentoDocumento.documento_Id = tipoRequerimentoDocumento.documento_Id.toString();
                tipoRequerimentoDocumento.obrigatorio = tipoRequerimentoDocumento.obrigatorio.toString();
                return tipoRequerimentoDocumento;
            });
            setTipoRequerimento(response.data);
        }).catch(ex => {
            showMessage("Erro", ex.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega as etapas da list
    const loadEtapas = (callback) => {
        setLoading(true);
        tipoRequerimento_api.GetTipoRequerimentoEtapas(tipoRequerimento.id).then(response => {
            const _tipoRequerimento = { ...tipoRequerimento };

            _tipoRequerimento.tipoRequerimentoEtapas = response.data.map(value => {
                value.inicial = value.inicial.toString();
                value.final = value.final.toString();
                return value;
            });

            setTipoRequerimento({ ..._tipoRequerimento });
            if (callback)
                callback();
        }).catch(ex => showMessage("Aviso!", ex.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        if (id) {

            loadTipoRequerimento(id);
        }
    }, []);

    //Função que retorna o valor do passo ativo
    const getContent = () => {
        switch (activeStep) {
            case 3:
                return <Workflow
                    tipoRequerimento={tipoRequerimento}
                    setTipoRequerimento={setTipoRequerimento}
                    editavel={editavel}
                />
            case 2:
                return <Etapas
                    tipoRequerimento={tipoRequerimento}
                    setTipoRequerimento={setTipoRequerimento}
                    loadEtapas={loadEtapas}
                    editavel={editavel}
                />
            case 1:
                return <Identificacao
                    tipoRequerimento={tipoRequerimento}
                    setTipoRequerimento={setTipoRequerimento}
                    loadTipoRequerimento={loadTipoRequerimento}
                    editavel={editavel}
                />
        }
    }
    return (
        <>
            <Button onClick={btnVoltar} className='px-4'><FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar</Button>
            <MainCard>
                <Nav tabs>
                    <NavItem className='ms-2'>
                        <NavLink
                            role='button'
                            style={{ backgroundColor: activeStep == 1 ? "#fff" : "#ccc" }}
                            className={`${activeStep == 1 ? "active fw-bold text-success" : "text-secondary "}`}
                            onClick={() => { setActiveStep(1); }}
                        >
                            Tipo de requerimento
                        </NavLink>
                    </NavItem>
                    <NavItem className='ms-2'>
                        <NavLink
                            role='button'
                            style={{ backgroundColor: activeStep == 2 ? "#fff" : "#ccc" }}
                            className={`${activeStep == 2 ? "active fw-bold text-success" : "text-secondary "}`}
                            onClick={() => {
                                if (!tipoRequerimento.id) {
                                    showMessage("Aviso", "Salve o tipo de requerimento para cadastrar as etapas", "info", null);
                                    return;
                                }

                                setActiveStep(2);
                            }}
                        >
                            Etapas
                        </NavLink>
                    </NavItem>
                    <NavItem className='ms-2'>
                        <NavLink
                            role='button'
                            style={{ backgroundColor: activeStep == 3 ? "#fff" : "#ccc" }}
                            className={`${activeStep == 3 ? "active fw-bold text-success" : "text-secondary "}`}
                            onClick={() => {
                                if (!tipoRequerimento.id || (!!tipoRequerimento.tipoRequerimentoEtapas && tipoRequerimento.tipoRequerimentoEtapas.length == 0)) {
                                    showMessage("Aviso", "Salve o tipo de requerimento e cadastre etapas para cadastrar o workflow", "info", null);
                                    return;
                                }
                                if (!!tipoRequerimento.tipoRequerimentoEtapas) {
                                    setActiveStep(3);
                                } else {
                                    loadEtapas(() => setActiveStep(3));
                                }
                            }}
                        >
                            Workflow
                        </NavLink>
                    </NavItem>
                </Nav>
                <div className="mt-4">
                    {getContent()}
                </div>
            </MainCard>
        </>
    )
}